import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgIf} from "@angular/common";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {AuthAccountInfoComponent} from "../auth-account-info/auth-account-info.component";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {StorageService} from "../../../services/storage.service";
import {v4 as uuidv4} from 'uuid';
import {AuthConstants, ExternalLogonProviderState} from "../../shared";


@Component({
  selector: 'auth-user-login',
  templateUrl: './login.component.html',
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    AuthAccountInfoComponent,
    ErrorPanelComponent,
    QuickPreviewPanelComponent,
    ActionsContainerComponent
  ],
  standalone: true
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup
  loading = false
  error = undefined

  authReason?: string
  authDescription?: string

  stateId: string

  constructor(
    readonly store: StorageService,
    readonly authService: AuthService,
    readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
    readonly fb: FormBuilder
  ) {
    this.stateId = uuidv4()
    this.store.setItem<ExternalLogonProviderState>(
      AuthConstants.storageKeys.externalIdentityProviders.gState, {
        state: this.stateId,
        createdAt: Date.now()
      }
    )
    this.loginForm = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    })
  }

  submit(): void {
    if (this.loginForm.valid) {
      this.loading = true
      this.error = undefined
      this.authService.authenticate(
        this.loginForm.value['username'],
        this.loginForm.value['password'],
      ).subscribe({
        next: (_) => {
          this.loading = false
          const returnUri = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/'
          let url = decodeURIComponent(returnUri)
          url = url.startsWith('/auth') ? '/' : url
          this.router.navigateByUrl(url)
            .catch(e => {
              console.error(e)
            })
            .finally(() => {})
        },
        error: (err) => {
          this.loading = false
          this.error = err
        }
      })
    }
  }

  ngOnInit(): void {
    this.invalidateAuthReason()
  }

  invalidateAuthReason() {
    this.authReason = undefined
    this.authDescription = undefined
    if ('reason' in this.activatedRoute.snapshot.queryParams) {
      this.authReason = this.activatedRoute.snapshot.queryParams['reason'] as string
      switch (this.authReason) {
        case 'tokenMissingOrExpired':
          this.authDescription = 'You are nog logged in or your session has expired.'
          break
        case 'tokenExpiration':
          this.authDescription = 'Your session has expired.'
          break
        default:
          break
      }
    }
  }
}
